<template>
  <HanziWithPinyin
    :content="props.card.hanzi"
    :singleLine="props.singleLine"
  />
</template>

<script lang="ts" setup>
import type { KidHanziCard } from '@/types/model'
import HanziWithPinyin from './HanziWithPinyin.vue'

const props = defineProps<{
  card: KidHanziCard
  singleLine?: boolean
}>()
</script>

<style scoped></style>
